import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { getIleggelseMakuleringer as getIleggelseMakuleringerAction } from "../../../actions/ileggelseMakuleringerActions";
import { getMostRecentObjectComparedOnParameter } from "../../../utils/date";

export default function MakuleringsarsakContainer() {
  const dispatch = useDispatch();
  const ileggelse = useSelector((state) => state.ileggelse);
  const mostRecentMakulering = useSelector((state) =>
    state.ileggelseMakuleringer
      ? getMostRecentObjectComparedOnParameter(
          state.ileggelseMakuleringer,
          "makuleringDato"
        )
      : null
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (ileggelse && ileggelse.id) {
      dispatch(getIleggelseMakuleringerAction(ileggelse.id));
    }
  }, []);

  return (
    <section className="detalj-ileggelse-section-margin">
      <div style={{ marginTop: 17 }}>
        <h5>Makuleringsårsak</h5>
        <Row>
          <Col md={6}>
            <p style={{ fontSize: 16 }}>
              {(ileggelse &&
                ileggelse.isMakulert &&
                mostRecentMakulering &&
                ileggelse.id === mostRecentMakulering.ileggelseId &&
                mostRecentMakulering.kommentar) ||
                "-"}
            </p>
          </Col>
        </Row>
      </div>
    </section>
  );
}
